
function radToDeg(angle) {
    return angle * 180 / Math.PI;
}

class RoomConfigurator {

    private coordinates: number[][]

    constructor(roomCoordinates: number[][], scale: number = 1, private disableFence = false, private firstIdCount = 0) {
        this.coordinates = roomCoordinates.map(xy => xy.map(v => v * scale));
    }

    addToScene(scene) {
        let minX = 9999;
        let maxX = -9999;
        let minY = 9999;
        let maxY = -9999;
        let fence = [];
        for (let i = 0; i < this.coordinates.length; i++) {
            let begin = this.coordinates[i];
            fence.push(begin[0]);
            fence.push(begin[1]);
            let end = this.coordinates[(i + 1) % this.coordinates.length];

            if (begin[0] < minX) {
                minX = begin[0];
            }
            if (begin[1] < minY) {
                minY = begin[1];
            }
            if (begin[0] > maxX) {
                maxX = begin[0];
            }
            if (begin[1] > maxY) {
                maxY = begin[1];
            }

            const height = 3;
            const wallPosition = {
                begin: {
                    x: begin[0],
                    y: begin[1]
                },
                end: {
                    x: end[0],
                    y: end[1]
                }
            };
            const diffX = (wallPosition.end.x - wallPosition.begin.x);
            const diffY = (wallPosition.end.y - wallPosition.begin.y);
            const width = Math.sqrt(diffX * diffX + diffY * diffY);
            const angle = -radToDeg(Math.atan(diffY / diffX));

            const x = wallPosition.begin.x + diffX / 2;
            const y = height / 2;
            const z = wallPosition.begin.y + diffY / 2;
            const position = `${x} ${y} ${z}`;

            const wall = document.createElement('a-plane');
            wall.classList.add('wall');
            wall.setAttribute('color', '#F2F2F2');
            wall.setAttribute('width', "" + width);
            wall.setAttribute('height', "" + height);
            wall.setAttribute('position', position);
            wall.setAttribute('rotation', `0 ${angle} 0`);
            wall.setAttribute('material', 'side:double');
            wall.setAttribute('shadow', 'cast:true; receive: false;');
            const id = 'wall-' + (this.firstIdCount + i);
            wall.id = id;
            scene.appendChild(wall);
        }
        if (!this.disableFence) {
            const floorPlane = document.getElementById('floor-plane');
            floorPlane.setAttribute('width', "" + (maxX - minX));
            floorPlane.setAttribute('height', "" + (maxY - minY));
            floorPlane.setAttribute('position', `${minX + (maxX - minX) / 2} 0 ${minY + (maxY - minY) / 2}`)

            let fenceCoordinates = this.coordinates.map(xy => xy.map(v => v * 0.90));
            const camera: any = document.querySelector('[wasd-controls]');
            camera.setAttribute('fence', { xyCoordinates: fenceCoordinates });
        }
    }
}